@let order = item();
@if (order) {
  <div class="order-general-info">
    @for (field of fields; track field.key) {
      <div class="order-general-info__field">
        <div class="order-general-info__label">
          {{ field.label | translate }}
        </div>
        <div class="order-general-info__value">
          @switch (field.key) {
            @case ('status') {
              <span class="status" [ngClass]="order.orderStatus.toLowerCase()">
                {{ formatOrderStatus(order.orderStatus) }}
              </span>
            }
            @case ('dateCreated') {
              <span>{{ order.dateCreated | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
            }
            @default {
              <span>{{ field.value(order) }}</span>
            }
          }
        </div>
      </div>
    }
  </div>
}
